<template>
    <h5-input :value="value" @input="handleInput" :placeholder="$t('请输入验证码')">
        <template v-slot:prepend>
            <i class="fa fa-shield" style="font-size:16px;color:#f9dda0;" />
        </template>
        <template v-slot:append>
            <button
                class="btn btn-text btn-primary"
                :disabled="countingDown"
                @click="getVerifyCode"
            >
                {{ buttonText }}
            </button>
        </template>
    </h5-input>
</template>

<script>
import { sendVerifyCode } from '@/service'
import H5Input from './H5Input'
import { $t } from '@/utils/languages'

export default {
    name: 'VerifyCode',
    components: { H5Input },
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        countDown: {
            type: Number,
            default: 60,
        },
        mobile: {
            type: [Number, String],
            required: true,
        },
        value: {
            type: [Number, String],
        },
        template: {
            type: Number,
        }
    },
    computed: {
        buttonText() {
            if (this.countingDown) {
                return `${this.time}${$t('秒后重新发送')}`
            } else {
                return $t('获取验证码')
            }
        },
    },
    data() {
        return {
            countingDown: false,
            time: 0,
            countDownInterval: null,
        }
    },
    methods: {
        startCountDown() {
            return new Promise(resolve => {
                this.time = this.countDown
                this.countDownInterval = setInterval(() => {
                    if (this.time > 0) {
                        this.time -= 1
                    } else {
                        clearInterval(this.countDownInterval)
                        resolve()
                    }
                }, 1000)
            })
        },
        getVerifyCode() {
            if (!this.mobile) {
                this.$toast($t('请输入邮箱'))
                return
            }
            if (!this.countingDown) {
                // send verify code
                let t = this.$toast({
                    message: $t('验证码发送中'),
                    duration: 0,
                })
                const params = { email: this.mobile }
                if (this.template == 1) params.template = 1
                sendVerifyCode(params).then(res => {
                    t && t.clear()
                    if (Number(res.code) === 0) {
                        this.countingDown = true
                        this.$toast($t('验证码已发送'))
                        this.startCountDown().then(() => {
                            this.countingDown = false
                        })
                    } else {
                        this.$toast(res.msg || $t('发送失败'))
                    }
                })
            }
        },
        handleInput(v) {
            this.$emit('change', v.target.value)
        },
        clearCountDown() {
            clearInterval(this.countDownInterval)
            this.time = 0
            this.countingDown = false
        },
    },
}
</script>
